<template>
  <div class="mx-auto flex w-full max-w-4xl flex-col gap-6 p-4">
    <header class="flex flex-col gap-2">
      <h1 class="text-2xl font-semibold text-slate-900">Notes</h1>
      <p class="text-sm text-slate-600">
        Select a noteable model and id to load and create notes.
      </p>
    </header>

    <div class="grid gap-4 rounded-lg border border-slate-200 bg-white p-4 sm:grid-cols-2">
      <label class="flex flex-col gap-2 text-sm">
        <span class="font-medium text-slate-700">Noteable model</span>
        <input
          v-model="noteableModel"
          class="rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-slate-500 focus:outline-none"
          placeholder="App\\Models\\User"
          type="text"
        >
      </label>

      <label class="flex flex-col gap-2 text-sm">
        <span class="font-medium text-slate-700">Noteable id</span>
        <input
          v-model.number="noteableId"
          class="rounded-md border border-slate-300 px-3 py-2 text-sm focus:border-slate-500 focus:outline-none"
          min="1"
          type="number"
        >
      </label>
    </div>

    <NotesCard :id="noteableId" :noteable="noteableModel" />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import NotesCard from '../components/notes/NotesCard.vue'

const noteableModel = ref('App\\Models\\User')
const noteableId = ref(1)
</script>
